import React, { useState } from 'react';
import {
  Button,
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { EmailPhoneInput } from '../EmailPhoneInput/EmailPhoneInput';
import { emailValidator } from '../../common/sharedFunctions';
import { IconFromSVG } from '../IconFromSVG/IconFromSVG';
import { phoneValidator } from '../PhoneFieldFormatter/PhoneFieldFormatter';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';

export const NewSearchModal = ({ handleSearch, handleCancel, isMobile }) => {

  const [opened, toggleOpened] = useState(true);
  const [phoneInput, setPhoneInput] = useState('');
  const [emailInput, setEmailInput] = useState('');

  const validInput = phoneValidator(phoneInput) || emailValidator(emailInput);

  const handleSearchClick = () => {
    const email = emailValidator(emailInput) ? emailInput : undefined;
    const phone = phoneValidator(phoneInput) ? phoneInput : undefined;
    handleSearch(email, phone);
    toggleOpened(false);
  };

  const handleCancelClick = () => {
    toggleOpened(false);
    handleCancel();
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={handleCancelClick}
      open={opened}
    >
      <div className="preferences-modal__content">
        <div className="sui-mb-4">
          {isMobile ? (
            <b>New Search</b>
          ) : (
            <div className="sui-flex sui-items-center">
              <IconFromSVG
                src="https://assets.homedepot-static.com/images/search-orange.svg"
                width="35px"
                marginRight="10px"
              />
              <h1>New Search</h1>
            </div>
          )}
        </div>
        <div>
          <h3>
            Please search by marketing preference attribute(s).
            You may search by one or more attributes at once.
          </h3>
        </div>
        <EmailPhoneInput
          name="new-search"
          phoneCallback={setPhoneInput}
          phoneValue={phoneInput}
          emailCallback={setEmailInput}
          emailValue={emailInput}
        />
        {!isMobile && (
          <hr className="hr-line sui-mt-4" />
        )}
        <div className="sui-grid sui-grid-cols-12">
          <div className="sui-col-span-8" />
          <div className="sui-col-span-4 sui-mt-4">
            <Button
              data-testid="newSearchButton"
              fullWidth
              onClick={handleSearchClick}
              disabled={!validInput}
            >
              Search
            </Button>
          </div>
        </div>
      </div>
    </MobileAwareOverlay>
  );
};

NewSearchModal.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

NewSearchModal.defaultProps = {
  isMobile: false,
};
